/*
  CEBE theme — assets/cebe-product.js, part 1 of 2: helpers, state of the adds and their requests.
  Load all parts in this order, each with defer: cebe-product-part-1.js, cebe-product-part-2.js.
  Made by website/review/sammel-2026-10-03/werkzeuge/zusammenfuehren.py from assets/cebe-product.js (MD5 6efbd99c46b8b988275afc40f21524c2);
  every Shopify upload file must stay below 26 000 bytes. Between the markers stands the original code; the only change:
  a name that one part changes and another reads, or that comes from a later part, reads cebeShared.<name> (one private
  object, window.__cebeParts.product). See website/review/sammel-2026-10-03/TEILUNG.md.
*/
/*
  CEBE theme — product page and the home coffees (loaded by sections/cebe-main-product.liquid and
  sections/cebe-product-tower.liquid). Each form finds its own error line in its [data-cebe-product].
  Progressive enhancement: the form still posts to /cart/add without this file.
*/
(function () {
  'use strict';

  var cebeShared = (window.__cebeParts = window.__cebeParts || {}).product || (window.__cebeParts.product = {});
  cebeShared.done = 0; // a new run of part 1 starts the chain again

  /* ---- assets/cebe-product.js, lines 8–329 ---- */

  var config = window.cebe || {};
  if (!config.cart) return;
  var $ = config.$;
  var $$ = config.$$;
  var announce = config.announce;
  var cart = config.cart;
  var reduceMotion = config.reduceMotion;

  function errorLine(form) {
    return $('[data-cebe-form-error]', form.closest('[data-cebe-product]') || document);
  }

  function showFormError(form, message) {
    var node = errorLine(form);
    if (!node) return;
    node.textContent = message || '';
    node.hidden = !message;
  }

  /* ---------- Add to cart without leaving the page ----------
     States (snippets/cebe-add-button.liquid): pending (looks idle) → busy after 200 ms (fast answers never show a
     spinner) → done "Added ✓" for 1.6 s → idle. The accessible name stays "Add to cart"; only while the customer has to
     decide (see below) the button says "Add anyway".
     A lost answer, a server fault or a late answer does not prove that nothing was added, and the server may still carry
     out a request the browser has given up on. A time limit on this page never turns such an outcome into "not added".
     Per coffee (variant) an add is
     - confirmed: by its answer, or by the cart (/cart.js) holding its target quantity → "Added", the drawer as the server
       holds it. A late answer, after the tap has been answered, is drawn quietly and spoken; the line goes;
     - on its way: sent, no answer yet (the request is not stopped before FLIGHT);
     - unconfirmed: no answer says so and the cart does not show it (yet) → "We couldn’t confirm that this was added."
     The cart's number confirms an add only while nothing else of this page may stand behind it: a quantity change of
     that coffee in the drawer moves the target to the number the server answers (an open add comes on top of it); without
     that answer, and after "Add anyway" (an add given up may still be carried out), only an answer or the customer decides.
     The next tap on an unconfirmed coffee reads the cart and adds nothing ("Checking…"): there → "Added"; still on its way
     → it waits for it and reads once more; not there and nothing on its way any more → it says that it may still be added,
     and the button says "Add anyway". Only a tap on it after ARM adds again, after one more read (a double tap reads only).
     Nothing is ever sent on its own.
     "Check out" (assets/cebe.js) does not start while an add of this page is on its way or unconfirmed (the hold below).
     Times: after 10 s without an answer the cart is read; 15 s after the tap the button is usable again at the latest
     (a hanging cart queue included); after 30 s an unanswered add request is stopped, its outcome stays unconfirmed. */
  var BUSY_DELAY = 200;
  var DONE_TIME = 1600;
  var WAIT = 10000; // for the add answer before the cart is read; also the most a read may take
  var LIMIT = 15000; // from the tap: the button is usable again and the cart queue is free
  var RESERVE = 3000; // of the limit, kept for the last read of a new tap that waits for an earlier add
  var GRACE = 1000; // for the drawer once /cart.js has answered; else it reloads itself after "Added"
  var FLIGHT = 30000; // an add request without an answer by then is stopped; its outcome stays unconfirmed
  var ARM = 1000; // "Add anyway" counts once it has been on screen this long; a tap before only reads the cart again
  var strings = config.strings || {};
  // Texts for an unconfirmed add (M-9). Locale keys may replace them through window.cebe.strings (layout/theme.liquid).
  var UNCONFIRMED = strings.addUnconfirmed || 'We couldn’t confirm that this was added. Trying again only checks your bag.';
  var MISSING = strings.addMissing || 'It isn’t in your bag yet, but it may still be added. Adding it again could add it twice.';
  var ANYWAY = strings.addAnyway || 'Add anyway';
  var CHECKING = strings.addChecking || 'Checking…';
  var resets = [];
  var forms = []; // every add form with its buttons, for the "Add anyway" label
  // variant id → the add of it whose outcome no tap has confirmed yet: { id, base, want, target, flight, form, blind,
  // result, accepted, watch } (see send)
  var doubts = {};
  cebeShared.ghosts = {}; // variant id → true: an add given up for "Add anyway" may still be carried out ("Check out" waits)
  var flights = {}; // variant id → its latest add request while that is still on its way
  cebeShared.travelling = []; // every add request of this page still on its way
  cebeShared.anyway = {}; // variant id → { armed }: read, not there, nothing on its way; once armed, a tap on it adds anyway
  cebeShared.serial = 0; // adds sent; a decision to check out covers only what was unconfirmed when it was offered

  // Tells assets/cebe.js that what holds "Check out" may have changed (it hides the express buttons meanwhile).
  function notify() {
    if (cart.holdChanged) cart.holdChanged();
  }

  function live(doubt) {
    return Boolean(doubt) && doubts[doubt.id] === doubt;
  }

  function onItsWay(flight) {
    return Boolean(flight) && cebeShared.travelling.indexOf(flight) !== -1;
  }

  // Does the cart (quantity of this coffee as /cart.js says now) confirm this add? Its late answer has (result), or the
  // cart holds its target and nothing else of this page may stand behind that number (blind, ghosts). Never once refused.
  function shows(doubt, quantity) {
    if (doubt.result) return doubt.result === 'applied';
    return !doubt.blind && !cebeShared.ghosts[doubt.id] && quantity >= doubt.target;
  }

  function countSource() {
    var drawer = $('[data-cebe-drawer]');
    return drawer ? $('[data-cebe-cart-count-source]', drawer) : null;
  }

  // Until the drawer is drawn from the server again, the next add reads the cart first (see drawnQuantity).
  function markUnsure() {
    var source = countSource();
    if (source) source.cebeUnsure = true;
  }

  // What the drawer holds of this variant (all of its lines), but only while it surely shows what the server drew last:
  // no error line (a change that failed leaves its typed number standing), the lines add up to the server's count, and
  // no drawing is still open (markUnsure). Else null: then the cart is read first.
  function drawnQuantity(id) {
    var drawer = $('[data-cebe-drawer]');
    var source = countSource();
    var error = drawer && $('[data-cebe-drawer-error]', drawer);
    if (!source || source.cebeUnsure || (error && !error.hidden)) return null;
    var total = 0;
    var mine = 0;
    $$('[data-cebe-key]', drawer).forEach(function (line) {
      var quantity = parseInt(line.dataset.cebeQuantity, 10) || 0;
      total += quantity;
      if (String(line.dataset.cebeKey).split(':')[0] === id) mine += quantity;
    });
    return total === (parseInt(source.textContent, 10) || 0) ? mine : null;
  }

  // Draws the drawer from a server answer (without a section it reloads itself). True when drawn at once; else (a reload,
  // or a newer answer rules) it may stay behind the server: marked, so that the next add reads the cart first.
  function drawFrom(job, html, opts) {
    var before = countSource();
    job.draw(html, opts);
    if (!before || countSource() !== before) return true;
    before.cebeUnsure = true;
    return false;
  }

  function sectionOf(data) {
    return (data && data.sections && data.sections[cart.sectionId()]) || null;
  }

  // Waits for `promise` at most `wait` ms (null: only until the tap's limit). Settles like it, or rejects with
  // { timeout: true }; the promise itself goes on.
  function within(job, promise, wait) {
    return new Promise(function (resolve, reject) {
      var timer = wait === null ? 0 : window.setTimeout(stop, wait);
      function stop() {
        reject({ timeout: true });
      }
      job.stops.push(stop);
      promise.then(
        function (value) {
          window.clearTimeout(timer);
          resolve(value);
        },
        function (error) {
          window.clearTimeout(timer);
          reject(error);
        }
      );
    });
  }

  // A request stopped after `wait` ms (the server may still carry it out). Rejects like readJson, or with { timeout: true }.
  function limited(url, options, wait) {
    var controller = window.AbortController ? new window.AbortController() : null;
    if (controller) options.signal = controller.signal;
    return new Promise(function (resolve, reject) {
      var timer = window.setTimeout(function () {
        if (controller) controller.abort();
        reject({ timeout: true });
      }, wait);
      fetch(url, options)
        .then(config.readJson)
        .then(
          function (data) {
            window.clearTimeout(timer);
            resolve(data);
          },
          function (error) {
            window.clearTimeout(timer);
            reject(error);
          }
        );
    });
  }

  // A read of this tap: stopped after `wait` ms, or with the whole tap at the limit. Rejects like readJson, or with
  // { timeout: true }; a late answer after that changes nothing.
  function timedFetch(job, url, options, wait) {
    var controller = window.AbortController ? new window.AbortController() : null;
    if (controller) options.signal = controller.signal;
    var read = within(job, fetch(url, options).then(config.readJson), wait);
    read.then(null, function (error) {
      if (controller && error && error.timeout) controller.abort();
    });
    return read;
  }

  // The add request. It is not stopped while the customer waits: the server may still apply it, and only its answer
  // (or the browser's error) tells. Unanswered after FLIGHT it is stopped; its outcome stays unconfirmed (doubts).
  // While it is on its way, flights[id] and travelling hold it.
  function postAdd(id, body) {
    var flight = { doubt: null }; // doubt: the record in doubts for this request (send)
    flight.answer = limited(config.routes.cartAdd, { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: body }, FLIGHT);
    if (id) flights[id] = flight;
    cebeShared.travelling.push(flight);
    // The first reaction to its answer: from here on it is no longer on its way.
    flight.answer.then(landed, landed);
    function landed() {
      if (flights[id] === flight) delete flights[id];
      cebeShared.travelling = cebeShared.travelling.filter(function (other) {
        return other !== flight;
      });
      notify();
    }
    return flight;
  }

  // Draws the drawer as the server holds it now, in the cart queue (a late answer that could not be drawn at once).
  // Resolves with true once drawn.
  function reload() {
    return new Promise(function (resolve) {
      cart.run(function (draw) {
        var before = countSource();
        return limited((config.routes.root || '/') + '?sections=' + cart.sectionId(), { headers: { Accept: 'application/json' } }, WAIT).then(
          function (sections) {
            draw((sections && sections[cart.sectionId()]) || null, { keepScroll: true });
            resolve(!before || countSource() !== before);
          },
          function () {
            resolve(false);
          }
        );
      });
    });
  }

  // From a cart answer (/cart.js, or /cart/change.js): how many of this variant the cart holds, and one of its items.
  function cartQuantity(data, id) {
    var found = { quantity: 0, item: null };
    ((data && data.items) || []).forEach(function (item) {
      if (String(item.variant_id || String(item.key || '').split(':')[0]) !== id) return;
      found.quantity += item.quantity || 0;
      found.item = found.item || item;
    });
    return found;
  }

  function setState(buttons, state) {
    buttons.forEach(function (button) {
      if (state === 'idle') button.removeAttribute('data-state');
      else button.setAttribute('data-state', state);
      if (state === 'pending' || state === 'busy') button.setAttribute('aria-disabled', 'true');
      else button.removeAttribute('aria-disabled');
    });
  }

  // A tap that only reads the cart says "Checking…" while busy, not "Adding…".
  function busyText(buttons, checking) {
    buttons.forEach(function (button) {
      var text = $('.cebe-stateful__busy-text', button);
      if (!text) return;
      if (text.cebeOwn === undefined) text.cebeOwn = text.textContent;
      text.textContent = checking ? CHECKING : text.cebeOwn;
    });
  }

  // The variant a form adds now (the variant select or radios may change it).
  function variantOf(form) {
    var data = new FormData(form);
    return typeof data.get === 'function' ? String(data.get('id') || '') : '';
  }

  // "Add anyway" on the buttons of every form whose coffee waits for that decision; else their own label again.
  function relabel() {
    forms.forEach(function (entry) {
      var id = variantOf(entry.form);
      var on = Boolean(id && cebeShared.anyway[id] && doubts[id]);
      entry.buttons.forEach(function (button) {
        var label = $('[data-cebe-add-label]', button);
        if (!label) return;
        if (on && label.cebeOwn === undefined) {
          label.cebeOwn = label.textContent;
          label.textContent = ANYWAY;
        } else if (!on && label.cebeOwn !== undefined) {
          label.textContent = label.cebeOwn;
          label.cebeOwn = undefined;
        }
      });
    });
  }

  // The error line of every form of this coffee still says it may be missing: `text` instead (empty: gone).
  function retell(id, text) {
    forms.forEach(function (entry) {
      var node = errorLine(entry.form);
      if (!node || node.hidden || variantOf(entry.form) !== id) return;
      if (node.textContent === UNCONFIRMED || node.textContent === MISSING) showFormError(entry.form, text);
    });
  }

  // The add is confirmed outside a tap (its late answer, drawn; or the cart that "Check out" read and drew).
  function confirmed(doubt) {
    if (!live(doubt)) return false;
    doubt.result = 'applied';
    delete doubts[doubt.id];
    delete cebeShared.anyway[doubt.id];
    relabel();
    retell(doubt.id, '');
    notify();
    return true;
  }

  // The cart refused the add (422 stock, 400): it added nothing.
  function refused(doubt, error) {
    doubt.result = 'refused';
    doubt.error = error;
    delete doubts[doubt.id];
    delete cebeShared.anyway[doubt.id];
    relabel();
    notify();
  }

  // "Pacamara Colombia · 200 g added to cart." — from the /cart/add.js answer.
  function addedMessage(data) {
    var item = data && data.items ? data.items[0] : data;
    var name = item && item.product_title;
    if (!name || !config.strings.addedItem) return config.strings.added;
    if (item.variant_title) name += ' – ' + item.variant_title;
    return config.strings.addedItem.replace('[product]', function () {
      return name;
    });
  }
  /* ---- end of lines 8–329 ---- */

  cebeShared.config = config;
  cebeShared.$ = $;
  cebeShared.$$ = $$;
  cebeShared.announce = announce;
  cebeShared.cart = cart;
  cebeShared.reduceMotion = reduceMotion;
  cebeShared.showFormError = showFormError;
  cebeShared.BUSY_DELAY = BUSY_DELAY;
  cebeShared.DONE_TIME = DONE_TIME;
  cebeShared.WAIT = WAIT;
  cebeShared.LIMIT = LIMIT;
  cebeShared.RESERVE = RESERVE;
  cebeShared.GRACE = GRACE;
  cebeShared.ARM = ARM;
  cebeShared.UNCONFIRMED = UNCONFIRMED;
  cebeShared.MISSING = MISSING;
  cebeShared.resets = resets;
  cebeShared.forms = forms;
  cebeShared.doubts = doubts;
  cebeShared.notify = notify;
  cebeShared.live = live;
  cebeShared.onItsWay = onItsWay;
  cebeShared.shows = shows;
  cebeShared.markUnsure = markUnsure;
  cebeShared.drawnQuantity = drawnQuantity;
  cebeShared.drawFrom = drawFrom;
  cebeShared.sectionOf = sectionOf;
  cebeShared.within = within;
  cebeShared.timedFetch = timedFetch;
  cebeShared.postAdd = postAdd;
  cebeShared.reload = reload;
  cebeShared.cartQuantity = cartQuantity;
  cebeShared.setState = setState;
  cebeShared.busyText = busyText;
  cebeShared.variantOf = variantOf;
  cebeShared.relabel = relabel;
  cebeShared.retell = retell;
  cebeShared.confirmed = confirmed;
  cebeShared.refused = refused;
  cebeShared.addedMessage = addedMessage;
  cebeShared.done = 1;
})();
